import { Popover2 } from '@blueprintjs/popover2'
import React from 'react'
import PulsatingDot from '../../../onboarding/Pulsating/PulsatingDot'
import firebase from 'firebase/app';


function ButtonsForInt({
    interests,
    setIntVal,
    onboarded,
    auth,
    intVal
}) {

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
      }

    const clickedDone = () =>{
        firebase
        .firestore()
        .collection('onboards')
        .doc(auth.uid)
        .update({
            // onboarded: "yes",
            intShown: "yes"
        })
    }

    return (
        <div
            className='flex items-start overflow-auto flex-wrap pb-4 pl-4 mt-2'
        >
            {interests ? interests.map((int, index) =>{
                if (((int !== 'null' && int !== "" && int !== 'null ' && int !== ' null') && int.length < 45 && index < 9)){
                    return(
                    <div
                    key={index}
                    >
                        <button
                        className={classNames(
                            intVal === int ? "bg-blue-700 text-white border-2 border-blue-800" : "border-2 border-gray-400 text-gray-800", "mr-2 text-sm mt-2 hover:bg-blue-600 hover:text-white font-semibold py-1 px-2 rounded-lg focus:outline-none"
                        )}
                        onClick={() =>setIntVal(int)}
                        >
                            {int}
                        </button>
                    </div>
                    )} else {
                        return null
                    }
            }) : null}
            {onboarded?.[0]?.intShown === 'no' ? 
            <Popover2
                content={
                    <div className="p-4 w-72">
                        <div className="text-lg font-semibold">
                            Reference Personal Topics
                        </div>
                        <div className="my-2">
                            Bound will search their Linkedin Bio and find any topics that are interesting to write about and show them here.<br /><br /> All you do is click on what topic you want to write about and Bound will incorporate it into the message and tie their interest into your value proposition.
                        </div>
                        <div className="mt-2 ml-auto">
                            <button 
                                onClick={clickedDone}
                                className="bg-red-600 hover:bg-red-500 text-white rounded-lg py-0.5 px-2 font-semibold"
                            >
                                Got It
                            </button>
                        </div>
                    </div>
                }
                interactionKind="hover"
                placement="right"
            >
                    <div className="-ml-4 mt-1">
                    <PulsatingDot />
                    </div>
            </Popover2>
            :
            null
            }
        </div>
    )
}

export default ButtonsForInt
